import React from 'react'
import { Translate, I18n } from "react-redux-i18n";
import { InputGroup } from "@blueprintjs/core";
import Map from '../GoogleLocation/GoogleMap';
import { GOOGLE_API_KEY } from '../../config';
import { usePlacesWidget } from "react-google-autocomplete";
import {ExploreRounded} from '@material-ui/icons/';

const LocationInput = ({ error, locationChanged }) => {
    const placeSelected = (place) => {
        const location = Map.parseSelectedPlace(place);
        locationChanged({ target: { id: 'address', value: location } });
    }

    const { ref } = usePlacesWidget({
        apiKey: GOOGLE_API_KEY,
        onPlaceSelected: placeSelected,
        options: { types: ['geocode'] },
    });

    const inputChanged = (event) => {
        if (!event.currentTarget.value) {
            locationChanged({ target: { id: 'address', value: null } });
        }
    }

    return (
        <div className={error ? "form-group error" : "form-group"} >
            <label htmlFor="address">
                {error &&
                    <Translate
                        value={error}
                    />
                }
            </label>
            <InputGroup
                inputRef={ref}
                placeholder={I18n.t("user_details.placeholders.location")}
                className="no-icon has-button"
                onChange={inputChanged}
                rightElement={
                    <div className="purchase-form-input-icon"><ExploreRounded className="icon" size="16" /></div>
                }
            />
        </div>
    )
}
export default LocationInput;